<template>
  <v-layer ref="layer" :config="config">
    <v-image :config="imgSloganTitle" />
    <v-image :config="imgSloganFoot" />
    <v-image ref="widget" :config="imageMainWidget" />
    <v-image ref="drawBtn" :config="imageBtn" />
  </v-layer>
</template>

<script>
import Konva from 'konva'
import ImageSloganTitle from '@/assets/event-ic-bg-slogan-title.png'
import ImageSloginFoot from '@/assets/event-ic-bg-slogan-foot.png'
import ImageMainWidget from '@/assets/event-ic-widget-01.png'
import ImageBtn from '@/assets/event-ic-btn-03.png'
import { help } from './help'

export default {
  mixins: [help],
  data() {
    return {
      config: {
        visible: true
      },
      imgLogo: {
        image: null,
        x: this.transformWH(35),
        y: this.transformWH(24)
      },
      imgSloganTitle: {
        image: null,
        x: this.transformWH(75),
        y: this.transformWH(196)
      },
      imgSloganFoot: {
        image: null,
        x: this.transformWH(285),
        y: this.transformWH(1244)
      },
      imageMainWidget: {
        visible: false,
        image: null,
        x: this.transformWH(390),
        y: this.transformWH(318)
      },
      imageBtn: {
        visible: false,
        image: null,
        x: this.transformWH(375),
        y: this.transformWH(1136)
      }
    }
  },
  async mounted() {
    await this.init()
    await this.startAnimation()
    await this.initEvent()
  },
  methods: {
    async init() {
      await this.placeImage(ImageSloganTitle, 'imgSloganTitle')
      await this.placeImage(ImageSloginFoot, 'imgSloganFoot')
      await this.placeImage(ImageMainWidget, 'imageMainWidget')
      await this.placeImage(ImageBtn, 'imageBtn')
    },
    async initEvent() {
      const drawBtn = this.$refs.drawBtn.getNode()
      drawBtn.on('touchstart', () => {
        this.$emit('draw')
      })

      // support for desktop
      drawBtn.on('click', () => {
        this.$emit('draw')
      })
      const stage = drawBtn.getStage()

      drawBtn.on('mouseenter', function() {
        stage.container().style.cursor = 'pointer'
      })
      drawBtn.on('mouseleave', function() {
        stage.container().style.cursor = 'default'
      })
    },
    async startAnimation() {
      const drawBtn = this.$refs.drawBtn.getNode()
      const widget = this.$refs.widget.getNode()

      drawBtn.offset({ x: drawBtn.getWidth() / 2, y: drawBtn.getHeight() / 2 })
      widget.offset({ x: widget.getWidth() / 2 })

      // avoid flip
      drawBtn.show()
      widget.show()
      const layerAni = new Konva.Animation((frame) => {
        const period = 2000
        const fnValue = (frame.time * 2 * Math.PI) / period

        // draw button animation
        const scale = Math.abs(Math.sin(fnValue) / 10) + 1
        drawBtn.setScale({ x: scale, y: scale })

        widget.rotation(Math.cos(fnValue) * 6)
      }, drawBtn.getLayer())

      layerAni.start()
    },
    async hide() {
      this.config.visible = false
    },
    async show() {
      this.config.visible = true
    }
  }
}
</script>
